import { render, staticRenderFns } from "./TeamRoot.vue?vue&type=template&id=bdb849b4&scoped=true"
import script from "./TeamRoot.vue?vue&type=script&lang=ts"
export * from "./TeamRoot.vue?vue&type=script&lang=ts"
import style0 from "./TeamRoot.vue?vue&type=style&index=0&id=bdb849b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdb849b4",
  null
  
)

export default component.exports